
// Refactored Assessment Page - now uses custom hooks and smaller components
import { useAssessmentLogic } from "@/hooks/useAssessmentLogic";
import AssessmentHeader from "@/components/assessment/AssessmentHeader";
import AssessmentContent from "@/components/assessment/AssessmentContent";

const Assessment = () => {
  const {
    assessmentState,
    currentQuestion,
    progress,
    session,
    handleAnswer,
    handleNext,
    handlePrevious,
    handleBackToHome,
    isAnswered
  } = useAssessmentLogic();

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/5 via-background to-secondary/5">
      <AssessmentHeader
        currentQuestionIndex={assessmentState.currentQuestionIndex}
        totalQuestions={6}
        sessionId={session?.sessionId}
        onBackToHome={handleBackToHome}
        isProcessing={assessmentState.isProcessing}
      />

      <AssessmentContent
        currentQuestionIndex={assessmentState.currentQuestionIndex}
        progress={progress}
        currentQuestion={currentQuestion}
        currentAnswer={assessmentState.answers[currentQuestion.id]}
        isAnswered={isAnswered}
        isProcessing={assessmentState.isProcessing}
        onAnswer={handleAnswer}
        onPrevious={handlePrevious}
        onNext={() => handleNext()}
      />
    </div>
  );
};

export default Assessment;
